import React from 'react';
import Icon from '../../../common/components/Icon';
import { ButtonProps } from '../types/Button';

const Button: React.FC<
  ButtonProps & {
    size?: 'small' | 'medium' | 'large';
    type?: 'primary' | 'secondary';
    fullWidth?: boolean;
    isDisabled?: boolean;
    className?: string;
    id?: string;
  }
> = ({
  size = 'medium',
  type = 'primary',
  onClick,
  href,
  label,
  iconName,
  fullWidth = false,
  isDisabled = false,
  className = '',
  id = '',
}) => {
  // Determining class names based on size prop
  const sizeClass = size === 'small' ? 'button--small' : size === 'medium' ? 'button--medium' : 'button--large';

  // Determining class names based on type prop
  const typeClass = type === 'primary' ? 'button--primary' : 'button--secondary';

  // Adding fullWidth class if needed
  const fullWidthClass = fullWidth ? 'button--full-width' : '';

  // Adding disabled class if needed
  const disabledClass = isDisabled ? 'button--disabled' : '';

  // Combining all class names
  const combinedClass = `button ${sizeClass} ${typeClass} ${fullWidthClass} ${disabledClass} ${className}`.trim();

  if (href) {
    return (
      <a id={id} href={href} className={combinedClass} onClick={isDisabled ? undefined : onClick}>
        {iconName ? <Icon name={iconName} size="small" /> : null} {label}
      </a>
    );
  } else {
    return (
      <button id={id} className={combinedClass} onClick={isDisabled ? undefined : onClick} disabled={isDisabled}>
        {iconName ? <Icon name={iconName} size="small" /> : null} {label}
      </button>
    );
  }
};

export default Button;
